module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c2bee5f9ed817c7dee456ad0eae22ae8.gif";